import React from 'react';
import './About.css';

const About = () => {
  const values = [
    {
      icon: '🎯',
      title: 'Our Mission',
      description: 'To empower businesses with cutting-edge technology solutions that drive digital transformation and sustainable growth in an ever-evolving digital landscape.'
    },
    {
      icon: '👁️',
      title: 'Our Vision',
      description: 'To be the most trusted technology partner globally, recognized for innovation, excellence, and delivering transformative solutions that shape the future.'
    },
    {
      icon: '⭐',
      title: 'Our Values',
      description: 'Innovation, Integrity, Excellence, Customer-Centricity, Collaboration, and Continuous Learning form the foundation of everything we do.'
    }
  ];

  const highlights = [
    { icon: '🏆', title: 'Excellence', description: 'Delivering the highest quality solutions' },
    { icon: '🚀', title: 'Innovation', description: 'Leveraging cutting-edge technologies' },
    { icon: '🤝', title: 'Partnership', description: 'Building lasting client relationships' },
    { icon: '⚡', title: 'Agility', description: 'Adapting to changing business needs' }
  ];

  return (
    <section className="about" id="about">
      <div className="container">
        <h2 className="section-title">About Us</h2>
        <p className="section-subtitle">
          Transforming businesses through innovation, expertise, and dedication
        </p>
        
        <div className="about-hero">
          <div className="about-hero-content">
            <h3>Who We Are</h3>
            <p>
              DT Consultancy is a premier technology consultancy firm dedicated to transforming 
              businesses through innovative digital solutions. With deep expertise across IT services, 
              data engineering, AI development, and design, we deliver comprehensive solutions that 
              drive measurable growth and operational efficiency.
            </p>
            <p>
              Our team of seasoned professionals brings together technical excellence and business 
              insight to create solutions that don't just meet expectations—they exceed them. We're 
              committed to building long-term partnerships founded on trust, transparency, and results.
            </p>
          </div>
          
          <div className="about-hero-visual">
            <div className="stat-circle circle-1">
              <div className="stat-value">150+</div>
              <div className="stat-label">Projects</div>
            </div>
            <div className="stat-circle circle-2">
              <div className="stat-value">50+</div>
              <div className="stat-label">Clients</div>
            </div>
            <div className="stat-circle circle-3">
              <div className="stat-value">5+</div>
              <div className="stat-label">Years</div>
            </div>
          </div>
        </div>

        <div className="values-section">
          {values.map((value, index) => (
            <div className="value-card" key={index}>
              <div className="value-icon">{value.icon}</div>
              <h4>{value.title}</h4>
              <p>{value.description}</p>
            </div>
          ))}
        </div>

        <div className="highlights-section">
          <h3 className="highlights-title">Why Choose Us</h3>
          <div className="highlights-grid">
            {highlights.map((highlight, index) => (
              <div className="highlight-card" key={index}>
                <div className="highlight-icon">{highlight.icon}</div>
                <h4>{highlight.title}</h4>
                <p>{highlight.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
